import React from "react";
import { object, shape, string, arrayOf } from "prop-types";
import EventsLandingPage from "../../organisms/EventsLandingPage";
import { useIsMobile } from "../../hooks/useIsMobile";

import "./sessions-landing-page.m.css";

export const SessionsLandingPage = ({ data, ...props }) => {
  const isMobile = useIsMobile();

  return (
    <EventsLandingPage
      data={data}
      eventType="sessions"
      className="sessions-landing-page"
      isMobile={isMobile}
      {...props}
    />
  );
};

SessionsLandingPage.propTypes = {
  data: shape({
    collection: shape({
      name: string,
      summary: string,
      "hero-image-s3-key": string,
      "hero-image-metadata": object
    }),
    upcomingSessions: arrayOf(
      shape({
        id: string,
        headline: string,
        subheadline: string,
        "hero-image-s3-key": string,
        "hero-image-metadata": object,
        slug: string,
        attributes: shape({
          "event-date": string,
          "event-location": string
        })
      })
    ),
    previousSessions: arrayOf(
      shape({
        id: string,
        headline: string,
        subheadline: string,
        "hero-image-s3-key": string,
        "hero-image-metadata": object,
        slug: string,
        attributes: shape({
          "event-date": string,
          "event-location": string
        })
      })
    )
  })
};

export default SessionsLandingPage;